export const checkAuthorized = (requiredRole, userRoles) => {
  if (!requiredRole) return false;
  if (!Array.isArray(userRoles)) return false;
  if (Array.isArray(requiredRole)) {
    return requiredRole.some((role) => userRoles.includes(role));
  }
  return userRoles.includes(requiredRole);
};
